import { BaseClient } from '../client';

export const deleteAdminGroupDealer = async ({ id }: { id: string }) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return 'Apagado com sucesso';
	// }

	try {
		const response = await BaseClient.delete<string>(`/GrupoConcessionarias/${id}`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		throw error;
	}
};
